import { useRecoilState } from "recoil";
import {
  modalOpenAtom,
  modalLoadingAtom,
  modalStrictlyFormAtom,
  modalComponentAtom,
  modalFormValuesAtom,
  modalCallbacksAtom,
  modalExtraDataAtom,
} from "../Modal/atoms";

export default function useModal() {
  const [modalOpen, setModalOpen] = useRecoilState(modalOpenAtom);
  const [modalLoading, setModalLoading] = useRecoilState(modalLoadingAtom);
  const [modalStrictlyForm, setModalStrictlyForm] = useRecoilState(
    modalStrictlyFormAtom
  );
  const [modalComponent, setModalComponent] =
    useRecoilState(modalComponentAtom);
  let [modalFormValues, setModalFormValues] =
    useRecoilState(modalFormValuesAtom);
  const [modalCallbacks, setModalCallbacks] =
    useRecoilState(modalCallbacksAtom);
  const [modalExtraData, setModalExtraData] =
    useRecoilState(modalExtraDataAtom);
  const toggleModal = (
    component,
    type,
    data = null,
    callbacks = null,
    extraData = null
  ) => {
    setModalLoading(true);
    if (type === "form") {
      setModalStrictlyForm(true);
    } else {
      setModalStrictlyForm(false);
    }
    if (component) {
      setModalComponent(component);
      setModalFormValues(data);
      setModalCallbacks(callbacks);
      setModalExtraData(extraData);
    }
    setModalOpen(!modalOpen);
    setModalLoading(false);
  };
  return {
    toggleModal,
    modalCallbacks,
    modalExtraData,
    modalLoading,
    setModalOpen,
  };
}
